<template>
  <div class="overflow-hidden">
    <div class="bg-light-purple">
      <div
        class="relative container items-center hero-section hero-section--search flex-l justify-between-l"
      >
        <div class="pa3 mb3 mb0-l pa0-l pr4-l w-55-l">
          <h1 class="ma0 mb4 mt2-l f2">
            {{ $t('referral.heading') }}
          </h1>
          <ReferralClaimForm :referral-code="referralCode" class="" />
        </div>
        <!-- <div
          class="h-100 w-60-l flex items-center justify-center relative overflow-hidden"
        >
          <img
            data-src="~assets/images/present-illustration.svg"
            alt=""
            class="lazyload"
            width="500"
            height="681"
          />
        </div> -->
        <div
          class="relative flex-l items-end-l pt4-l w-45-l overflow-hidden featured-pro-container"
        >
          <img
            :data-srcset="require('~/assets/images/featured-pro@2x.png').srcSet"
            data-src="~assets/images/featured-pro.png"
            alt="Featured Professional"
            class="lazyload max-h-100 featured-pro"
            :class="{ 'featured-pro-xl': $config.FT_HERO_TESTIMONIAL }"
          />
          <div
            v-if="$config.FT_HERO_TESTIMONIAL && testimonial"
            class="absolute hero-testimonial-container"
          >
            <div class="flex flex-row">
              <svg-icon
                v-for="(item, index) in new Array(5)"
                :key="index"
                name="icon-star"
                class="icon-star"
              />
            </div>
            <blockquote class="hero-testimonial">
              <p class="hero-testimonial-text">
                {{ testimonial.text }}
              </p>
              <cite class="db hero-testimonial-author">{{
                testimonial.client
              }}</cite>
            </blockquote>
          </div>
        </div>
        <div
          class="absolute flex items-center insurance-container"
          style="margin-left: -100px; bottom: 60px"
        >
          <span class="db mr2">
            <svg-icon name="icon-insurance" class="icon-insurance" />
          </span>
          <span class="db">{{ $t('home.insurancePromo') }}</span>
        </div>
      </div>
    </div>
    <div class="container pax20">
      <div class="flex flex-column items-center flex-row-l mv4">
        <div class="w-50-l mr2 flex justify-center">
          <div class="mv4 features-mw">
            <h2 class="f2 mb4 mt2">{{ $t('home.features.feature1Title') }}</h2>
            <p class="">
              {{ $t('home.features.feature1Description') }}
            </p>
          </div>
        </div>
        <div class="w-50-l ml2">
          <div class="pv4 flex justify-center features-screen features-mw">
            <img
              :data-srcset="require('~/assets/images/guide-find@2x.png').srcSet"
              data-src="~assets/images/guide-find.png"
              alt=""
              class="lazyload"
              width="274"
              height="477"
            />
          </div>
        </div>
      </div>
      <div
        class="flex flex-column items-center flex-row-l flex-row-reverse-l mb4"
      >
        <div class="w-50-l ml2 flex justify-center">
          <div class="mv4 features-mw">
            <h2 class="f2 mt2">{{ $t('home.features.feature2Title') }}</h2>
            <p class="">{{ $t('home.features.feature2Description') }}</p>
          </div>
        </div>
        <div class="w-50-l mr2 flex justify-end">
          <div class="pv4 flex justify-center features-screen features-mw flip">
            <img
              :data-srcset="
                require('~/assets/images/guide-manage@2x.png').srcSet
              "
              data-src="~assets/images/guide-manage.png"
              alt=""
              class="lazyload flip"
              width="274"
              height="477"
            />
          </div>
        </div>
      </div>
      <div class="flex flex-column items-center flex-row-l">
        <div class="w-50-l mr2 flex justify-center">
          <div class="mv4 features-mw">
            <h2 class="f2 mt2">{{ $t('home.features.feature3Title') }}</h2>
            <p class="">{{ $t('home.features.feature3Description') }}</p>
          </div>
        </div>
        <div class="w-50-l ml2">
          <div class="pv4 flex justify-center features-screen features-mw">
            <img
              :data-srcset="require('~/assets/images/guide-pay@2x.png').srcSet"
              data-src="~assets/images/guide-pay.png"
              alt=""
              class="lazyload"
              width="274"
              height="477"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="bg-near-white">
      <div
        class="featured-container-dn flex flex-column items-center flex-row-l tl relative"
      >
        <div class="container pax20 w-100">
          <div class="pr6-l ph0-m w-50-l">
            <h2 class="f2">
              {{ $t('referral.downloadNow.heading') }}
            </h2>
            <p class="mb2 pb2">{{ $t('referral.downloadNow.subheading1') }}</p>
            <p class="mb2 pb2">{{ $t('referral.downloadNow.subheading2') }}</p>
            <p class="mb2 pb2">{{ $t('referral.downloadNow.subheading3') }}</p>
            <p class="mb2 pb2">{{ $t('referral.downloadNow.subheading4') }}</p>

            <div class="flex">
              <a
                class="pointer dib white mt3 mb4 fw7 br-pill bg-green button-large"
                @click="$root.$emit('handle-download', 'ref-open')"
              >
                {{ $t('referral.downloadNow.cta') }}
              </a>
            </div>
          </div>
        </div>
        <div
          class="featured-image-container-dn absolute-l top-0 right-0 w-50-l"
        >
          <img
            :data-srcset="require('~/assets/images/download-app@2x.jpg').srcSet"
            data-src="~assets/images/download-app@2x.jpg"
            class="lazyload featured-image-dn"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReferralClaimForm from '~/components/ReferralClaimForm';
import reviews from '~/reviews';

export default {
  scrollToTop: true,
  components: {
    ReferralClaimForm,
  },
  asyncData({ app }) {
    const locale = app.i18n.locale;
    const language = locale.split('-')[0];
    let testimonial;
    const testimonials = reviews.filter((r) => {
      return r.language === language || (!r.language && language === 'lt');
    });
    if (testimonials.length) {
      testimonial =
        testimonials[Math.floor(Math.random() * testimonials.length)];
    }
    return { testimonial };
  },
  data() {
    return {
      error: null,
      success: null,
      phone: null,
      referralCode: this.$route.query.code || '',
    };
  },
  methods: {
    getLinkPrevewImage() {
      if (this.$i18n.locale.split('-')[0] === 'pl') {
        return 'https://firebasestorage.googleapis.com/v0/b/discontract-prod.appspot.com/o/assets%2FreferralsPL.jpg?alt=media&token=4a3591ed-a004-4101-9204-abe042a27b85';
      } else if (this.$i18n.locale.split('-')[0] === 'lt') {
        return 'https://firebasestorage.googleapis.com/v0/b/discontract-prod.appspot.com/o/posts%2Fimages%2Freferral-banner.jpg?alt=media&token=7b4c317f-a8f9-4e6e-94d2-7b1c10f62637';
      } else {
        return undefined;
      }
    },
  },
  head() {
    const locale =
      (this.$i18n.locale !== 'en-LT' && this.$i18n.locale + '/') || '';
    return {
      title: this.$t('referral.title'),
      meta: [
        // hid is used as unique identifier. Do not use `vmid` for it as it will not work
        {
          hid: 'description',
          name: 'description',
          content: this.$t('referral.description'),
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.$t('referral.description'),
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: this.getLinkPrevewImage(),
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.$t('referral.title'),
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://discontract.com/${locale}referral/`,
        },
      ],
    };
  },
};
</script>
